<template>
  <div>
    <NavigationBar
      titel="Dienstberichte"
      :actions="actions"
      showBackBtn
      isPreview
      dense
    >
    </NavigationBar>

    <MasterDetailWrapper
      ref="masterDetail"
      :selectedId="selectedId"
      queryParamKey="reportId"
      :syncRoute="true"
      :selectionDebounce="300"
      :initialSplitPosition="28"
      mobileAlertTitle="Split-Ansicht nicht verfügbar"
      mobileAlertText="Die Split-Ansicht ist auf kleinen Bildschirmen nicht verfügbar."
      :fallbackRoute="{
        name: 'duty-management-reports',
        params: { organizationId: $route.params.organizationId },
      }"
      fallbackRouteText="Zur Standardansicht"
      emptyStateIcon="mdi-file-document-outline"
      emptyStateTitle="Kein Bericht ausgewählt"
      emptyStateSubtitle="Dienstbericht auswählen, um Details anzuzeigen"
      @selection-change="onSelectionChange"
    >
      <template #master>
        <ReportsList
          :reports="reports"
          :selectedId="selectedId"
          :loading="reportsLoading"
          @select-report="onReportSelect"
        />
      </template>

      <template #detail>
        <ReportDetails
          v-if="selectedReport"
          :key="selectedId"
          :reportProp="selectedReport"
        />
      </template>
    </MasterDetailWrapper>

    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import MasterDetailWrapper from "@/components/_systemwide/MasterDetailWrapper.vue";
import ReportsList from "@/components/duty-management/ReportsList.vue";
import ReportDetails from "@/views/duty-management/reports/ReportDetails.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import { DUTY_MANAGEMENT } from "@/store/modules.js";
import { GET_REPORTS } from "@/store/action-types.js";
import {
  DUTY_MANAGEMENT_REPORTS_create,
  DUTY_MANAGEMENT_REPORTS_read_all,
} from "@/data/permission-types.js";

export default {
  name: "duty-management-reports-split-view",
  components: {
    NavigationBar,
    MasterDetailWrapper,
    ReportsList,
    ReportDetails,
    SupportTools,
  },
  data() {
    return {
      selectedId: null,
      actions: [
        {
          title: "Erstellen",
          permission: `${DUTY_MANAGEMENT_REPORTS_create}`,
          icon: "mdi-plus-circle",
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "duty-management-reports-new",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },
        { divider: true },
        { actionStyle: "clipboardBtn" },
      ],
    };
  },
  computed: {
    reports() {
      return this.$store.state.dutyManagement.reports;
    },
    reportsLoading() {
      return this.$store.state.dutyManagement.loading;
    },
    selectedReport() {
      if (!this.selectedId) return null;
      return (
        this.reports.find((report) => report.meta?.id === this.selectedId) ||
        null
      );
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        { title: "reports", data: this.reports },
        { title: "selectedReport", data: this.selectedReport },
      ];
    },
  },
  created() {
    this.initialize();
  },
  // Note: Don't unsubscribe here - listener should persist while user navigates
  // between views that share the same data. Cleanup happens when leaving the module.
  methods: {
    initialize() {
      // Initialize selection from route query
      if (this.$route.query.reportId) {
        this.selectedId = this.$route.query.reportId;
      }

      // Fetch reports with realtime listener
      const allowedToReadAllDutyReports = this.$store.getters[
        "organization/checkPermissionByID"
      ](`${DUTY_MANAGEMENT_REPORTS_read_all}`);

      if (allowedToReadAllDutyReports) {
        this.$store.dispatch(`${DUTY_MANAGEMENT}${GET_REPORTS}`, {
          organizationId: this.$route.params.organizationId,
          query: {
            queryIsFiltered: false,
          },
        });
      } else {
        this.$store.dispatch(`${DUTY_MANAGEMENT}${GET_REPORTS}`, {
          organizationId: this.$route.params.organizationId,
          query: {
            queryIsFiltered: true,
            onlyOwn: true,
          },
        });
      }
    },
    onReportSelect(report) {
      // Use the MasterDetailWrapper's selection handling with debounce
      this.$refs.masterDetail?.handleSelection(report.meta?.id);
    },
    onSelectionChange(id) {
      this.selectedId = id;
    },
  },
};
</script>
